import { Navigate, type RouteObject } from 'react-router';
import { PART_TYPE_ROUTES } from './features/part-types/part-types.routes';
import { TYRE_ROUTES } from './features/tyres/tyres.routes';
import { WORK_ORDER_ROUTES } from './features/work-orders/work-orders.routes';
import { MAINTENANCE_TABS, maintenanceTabPath } from './maintenance.paths';
import { MaintenancePage } from './pages/MaintenancePage';

/** Maintenance's tabs: service items, the garages directory, the parts-suppliers directory, the tyre register (and a tyre's own page), the parts fitted register, the part type catalogue (and a type's own page) and the service-type and category catalogues behind them. */
export const MAINTENANCE_ROUTES: RouteObject[] = [
  { path: 'maintenance', element: <Navigate to={maintenanceTabPath(MAINTENANCE_TABS[0])} replace /> },
  ...MAINTENANCE_TABS.map((tab) => ({ path: `maintenance/${tab}`, element: <MaintenancePage tab={tab} /> })),
  ...TYRE_ROUTES,
  ...PART_TYPE_ROUTES,
  ...WORK_ORDER_ROUTES,
];
